import styled from "styled-components";
import searchIcon from "images/search-24px.svg";
import searchHoverIcon from "images/search-24px-hover.svg";
import { media } from "../../../../../components/common/media";

const LandingTopContainer = styled.div`
  background: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)) no-repeat 50%;
  background-size: cover !important;
  height: 425px;
  position: relative;
  background-position-y: center;

  .lt-cta {
    position: absolute;
    width: 100%;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.6);
    text-align: center;
    padding: 15px 10px 0;
    p {
      color: #fff;
      font-size: 20px;
      line-height: 125%;
      span,
      a {
        color: ${(props) => props.theme.colors.primary.main}
      }
    }
  }

  .wire-hero {
    p {
      font-size: 15px !important;
      font-weight: normal !important;
      span {
        color: #fff;
        font-weight: 700;
        text-decoration: underline;
      }
    }
  }

  .layer {
    background: rgba(0, 0, 0, 0.5);
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    max-height: 425px;
  }

  .callout {
    position: relative;
    top: 35%;
    width: 100%;
    max-width: 950px;
    margin: 0 auto;
    transition: all 0.6s ease 0s;

    img {
      margin: 0 auto 18px;
    }
    h1 {
      font-size: 32px;
      color: #fff;
      font-weight: 700;
      margin-bottom: 22px;
      width: 100%;
      text-align: center;
      ${media.tablet`
        font-size: 24px;
        line-height: 115%;
      `};
    }

    form {
      width: 75%;
      margin: 0 auto;

      input[type="search"] {
        height: 52px;
        background: #fff;
        padding-left: 15px;
        padding-right: 15px;
        border-right: 0;
        font-size: 14px;
        color: #4a4a4a;
        border-radius: 0;
        &.error {
          border: 2px solid ${(props) => props.theme.colors.primary.main};
        }

        ${media.phone`
          font-size: 12px;
        `};
      }

      input[type="submit"] {
        background: url(${searchIcon}) center center no-repeat #fff;
        height: 52px;
        color: #fff;
        width: 60px;
        font-size: 16px;
        transition: all 0.6s ease 0s;
        margin-left: -1px;
        border: 1px solid #ced4da;
        border-left: 0;
        &:hover {
          background-image: url(${searchHoverIcon});
        }
        ${media.desktop`
          border-radius: 0;
          border: 1px solid #ced4da;
        `};
      }
    }

    p.searchError {
      padding-top: 2px;
      text-align: left;
      margin-left: 0;
      position: absolute;
    }
  }

  .search-tags {
    display: flex;
    margin-top: 25px;
    position: relative;
    ${media.desktop`
      display: block;
    `}
    button {
      background: none;
      border: 1px solid #fff;
      color: #fff;
      margin-right: 10px;
      margin-bottom: 10px;
      height: 30px;
      transition: all 0.6s ease 0s;
      &:hover {
        border: 1px solid ${(props) => props.theme.colors.primary.main}
        background: ${(props) => props.theme.colors.primary.main}
      }
    }
    a {
      position: absolute;
      right: 0;
      top: -20px;
      ${media.desktop`
        display: none;
      `}
      &.tags {
        position: relative;
        right: 0;
        ${media.desktop`
          display: inline-block;
        `}
      }
    }
  }
  a.advanceSearch {
    color: #fff;
    transition: all 0.6s ease 0s;
    font-size: 16px;
    font-weight: 400;
    line-height: 30px;
    text-decoration: underline;
    &:hover {
      color: ${(props) => props.theme.colors.primary.main}
    }
  }
  .search-all-mobile {
    display: none;
    text-align: center;
    margin-top: 25px;
    ${media.desktop`
      display: block;
    `}
  }

  @media screen and (max-width: 991px) {
    background-position: center;
  }

  @media screen and (max-width: 767px) {
  }

  @media screen and (max-width: 576px) {
  }
`;

export default LandingTopContainer;
